import React, { useState, useEffect } from "react";
import axios from "axios";
import { CheckToken } from "../login/AccessToken";
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom";
import "./BillingPayment.scss";
import { Card } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { toast } from "react-toastify";
import { Radio, RadioGroup } from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import Autocomplete from "@mui/material/Autocomplete";
import {
  Grid,
  TextField,
  Button,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Typography,
  Avatar,
  CardContent,
  CircularProgress,
} from "@mui/material";
import { Checkbox, FormControlLabel } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import Icon from "../doctor-console/Utils/Icons";
import { ReactComponent as CalendarIcon } from './DummyIcons/calendar-silhouette 2.svg';
import SideNavbar from "./SideNavbar";
import ServiceAdditionOnTheGo from "./ServiceAdditionOnTheGo";
import InvoicePayment from "./InvoicePayment";
import { StyledTextFieldBootstrap } from "../doctor-console/StyledComponents";
import { normalizeBase64Image } from "../utils/utils";
import { displayPatientName } from "../../utils/displayPatientName";

const EditInvoice = () => {
  const today = new Date().toISOString().split("T")[0];
  const [itemsList, setItemsList] = useState([
    { items: "", quantity: "", price: "", amount: "", category: "services" },
  ]);
  const [subtotal, setSubtotal] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [tax, setTax] = useState(0);
  const [referredBy, setReferredBy] = useState("");
  const [notes, setNotes] = useState("");
  const [selectedPatientId, setSelectedPatientId] = useState("");
  const [selectedPatientName, setSelectedPatientName] = useState("");
  const [finalTotal, setFinalTotal] = useState();

  const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;
  const [patientList, setPatientList] = useState([]);
  const [services, setServices] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("services");
  const [servicesList, setServicesList] = useState([]);
  const [openCreateServiceModal, setOpenCreateServiceModal] = useState(false);
  const [activeRowIndex, setActiveRowIndex] = useState(null);
  const [openPatientSearch, setOpenPatientSearch] = useState(false);
  const [patientSearchType, setPatientSearchType] = useState("abhaId");
  const [patientSearchQuery, setPatientSearchQuery] = useState("");
  const [patientSearchName, setPatientSearchName] = useState("");
  const [patientSearchGender, setPatientSearchGender] = useState("");
  const [patientSearchDob, setPatientSearchDob] = useState("");
  const [patientSearchResults, setPatientSearchResults] = useState([]);
  const [isPatientSearching, setIsPatientSearching] = useState(false);
  const [selectedPatientSearchId, setSelectedPatientSearchId] = useState("");
  const [openPaymentModal, setOpenPaymentModal] = useState(false);
  const [invoiceForPayment, setInvoiceForPayment] = useState(null);
  const [productsList, setProductsList] = useState([]);
  // 
  const [invoiceDate, setInvoiceDate] = useState("");
  const [dueDate, setDueDate] = useState("");
  const { control, setValue } = useForm();
  const [fillExpiryDate, setFillExpiryDate] = useState(false);
  //
  const [authToken, setAuthToken] = useState(
    sessionStorage.getItem("accessToken") !== undefined &&
      sessionStorage.getItem("accessToken") !== null
      ? sessionStorage.getItem("accessToken")
      : ""
  );
  useEffect(() => {
    if (
      sessionStorage.getItem("accessToken") == undefined &&
      sessionStorage.getItem("accessToken") == null
    ) {
      history.push("/login");
    }
  }, []);
  const history = useHistory();
  const location = useLocation();
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };

  const Token = () => {
    const check = CheckToken();
    console.log(check);
    setAuthToken(sessionStorage.getItem("accessToken"));
    return check;
  };
  const [facilityName, setFacilityName] = useState(
    sessionStorage.getItem("facility_name") || ""
  );

  const calculateTotalAmount = () => {
    const itemsTotal = itemsList.reduce(
      (t, i) => t + Number(i.amount || 0),
      0
    );

    const discountAmount = itemsTotal * (discount / 100);
    const taxAmount = (itemsTotal - discountAmount) * (tax / 100);

    return (itemsTotal + taxAmount - discountAmount).toFixed(2);
  };

  const handleTotalChange = (field, value) => {
    let num = parseFloat(value);
    if (isNaN(num)) num = 0;

    if (field === "discount" || field === "tax") {
      if (num > 100) num = 100;
      if (num < 0) num = 0;
    }

    if (field === "discount") setDiscount(num);
    else if (field === "tax") setTax(num);
  };

  const fetchServicesList = () => {
    if (!authToken) return;
    axios
      .get(`${REACT_APP_BACKEND_ROUTE_URL}get_all_medical_services/`, {
        headers,
      })
      .then((res) => {
        const filteredServices = (res.data.service_list || []).filter(
          (service) => !service.expired && service.active
        );
        setServicesList(filteredServices);
        setServices(filteredServices);
      })
      .catch((err) => console.error("Error refreshing services:", err));
  };

  const handleServiceCreated = (service) => {
    if (!service) return;
    fetchServicesList();
    if (activeRowIndex === null || activeRowIndex === undefined) return;
    const updated = [...itemsList];
    if (!updated[activeRowIndex]) return;
    updated[activeRowIndex].items = service.medical_service_id;
    updated[activeRowIndex].price = Number(service.fee || 0).toFixed(2);
    updated[activeRowIndex].amount = (
      Number(updated[activeRowIndex].quantity || 1) * Number(service.fee || 0)
    ).toFixed(2);
    setItemsList(updated);
  };

  const itemFilterOptions = (options, { inputValue }) => {
    const search = inputValue.toLowerCase().trim();
    if (!search) return options;
    return options.filter((option) =>
      option.name && option.name.toLowerCase().startsWith(search)
    );
  };

  const formatAbhaNumber = (abhaNumber) => {
    const digits = String(abhaNumber || "").replace(/\D/g, "");
    if (digits.length !== 14) return abhaNumber || "";
    return digits.replace(/(\d{2})(\d{4})(\d{4})(\d{4})/, "$1-$2-$3-$4");
  };

  const runPatientSearch = async () => {
    if (!authToken) return;
    let filterCriteria;
    if (patientSearchType === "demographics") {
      if (
        !String(patientSearchName || "").trim() &&
        !String(patientSearchGender || "").trim() &&
        !String(patientSearchDob || "").trim()
      ) {
        toast.error("Please enter at least one demographic field.");
        return;
      }
      filterCriteria = {
        filter_type: "demographics",
        filter_details: {
          name: patientSearchName || "",
          gender: patientSearchGender || "",
          dob: patientSearchDob || "",
        },
        multipleResults: true,
      };
    } else {
      const q = String(patientSearchQuery || "").trim();
      if (!q) {
        toast.error("Please enter a search query.");
        return;
      }
      if (patientSearchType === "abhaId") {
        filterCriteria = {
          filter_type: "abha_id",
          filter_details: { abha_id: q },
          multipleResults: true,
        };
      } else if (patientSearchType === "abhaNo") {
        filterCriteria = {
          filter_type: "abha_number",
          filter_details: { abha_number: formatAbhaNumber(q) },
          multipleResults: true,
        };
      } else if (patientSearchType === "phoneNo") {
        filterCriteria = {
          filter_type: "phone_number",
          filter_details: { phone_number: q },
          multipleResults: true,
        };
      } else if (patientSearchType === "patientId") {
        filterCriteria = {
          filter_type: "patient_id",
          filter_details: { patient_id: q },
          multipleResults: true,
        };
      } else {
        toast.error("Invalid search type.");
        return;
      }
    }
    try {
      setIsPatientSearching(true);
      const res = await axios.post(
        `${REACT_APP_BACKEND_ROUTE_URL}get_filtered_patient_data/`,
        filterCriteria,
        { headers }
      );
      if (res?.data?.status === "Success") {
        const found = Array.isArray(res?.data?.patient_details)
          ? res.data.patient_details
          : [];
        setPatientSearchResults(found);
        setSelectedPatientSearchId("");
        toast.success("Patient Found Successfully");
      } else {
        setPatientSearchResults([]);
        setSelectedPatientSearchId("");
        toast.error(res?.data?.message || "No patient found");
      }
    } catch (e) {
      console.error("Patient search failed:", e);
      setPatientSearchResults([]);
      setSelectedPatientSearchId("");
      toast.error("Patient search failed");
    } finally {
      setIsPatientSearching(false);
    }
  };

  const selectPatientFromSearch = (patient) => {
    const id = patient?.patient_id;
    if (!id) return;
    setPatientList((prev) => {
      const list = Array.isArray(prev) ? prev : [];
      const map = new Map(list.map((p) => [p.patient_id, p]));
      map.set(id, { ...(map.get(id) || {}), ...(patient || {}) });
      return Array.from(map.values());
    });
    setSelectedPatientId(id);
    setSelectedPatientName(patient?.name || "");
    setOpenPatientSearch(false);
  };

  // ===================================================================

  // useEffect(() => {
  //   const total = subtotal * (1 - discount / 100) * (1 + tax / 100);
  //   setFinalTotal(total.toFixed(2));
  // }, [subtotal, discount, tax]);
  // NEW LOGIC (services only — products removed)

  useEffect(() => {
    if (authToken && servicesList.length > 0) {
      const { data } = location.state || {};

      if (data) {
        const initialItemsList = data.items.map((item) => {
          const matchedService =
            servicesList.find(
              (service) => service.medical_service_id === item.item_id
            ) || {};

          return {
            items: item.item_id,
            quantity: item.quantity,
            price: matchedService.fee
              ? Number(matchedService.fee).toFixed(2)
              : Number(item.item_price || 0).toFixed(2),
            amount: Number(item.subtotal || 0).toFixed(2),
            // category removed (only services now)
          };
        });

        setItemsList(initialItemsList);
      }
    }
  }, [location.state, servicesList, authToken]);


  // useEffect(() => {
  //   if (authToken && servicesList.length > 0 && productsList.length > 0) {
  //     const { data } = location.state || {};
  //     if (data) {
  //       const initialItemsList = data.items.map((item) => {
  //         const category =
  //           item.item_type === "Medical Service" ? "services" : "products";
  //         const matchedItem =
  //           (category === "services"
  //             ? servicesList.find(  
  //               (service) => service.medical_service_id === item.item_id
  //             )
  //             : productsList.find(
  //               (product) => product.product_id === item.item_id
  //             )) || {};

  //         return {
  //           items: item.item_id,
  //           quantity: item.quantity,  
  //           price: matchedItem.fee?.toFixed(2) || item.item_price.toFixed(2),
  //           amount: item.subtotal.toFixed(2),
  //           category,
  //         };
  //       });
  //       setItemsList(initialItemsList);
  //     }
  //   }
  // }, [location.state, servicesList, productsList, authToken]);

  useEffect(() => {
    if (authToken !== "") {
      // Fetch services
      axios
        .get(`${REACT_APP_BACKEND_ROUTE_URL}get_all_medical_services/`, {
          headers,
        })
        .then((res) => {
          const filteredServices = res.data.service_list.filter(
            (service) => !service.expired && service.active
          );
          setServicesList(filteredServices);
        });

      // Fetch products
      axios
        .get(`${REACT_APP_BACKEND_ROUTE_URL}get_all_medical_products/`, {
          headers,
        })
        .then((res) => {
          const filteredProducts = res.data.product_list.filter(
            (product) => !product.expired && product.active
          );
          setProductsList(filteredProducts);
        });
    }
  }, [authToken]);
  useEffect(() => {
    // Extract data from location state and set initial values for form fields
    const { data } = location.state || {};
    console.log("Extracted data:", data);
    if (data) {
      // Set initial values based on data
      const {
        invoice_id,
        invoice_date,
        due_date,
        invoice_number,
        items,
        total_amount,
        discount,
        note,
        referred_by,
        patient_id,
        name,
        partial_payment,
      } = data;
      const initialItemsList = items.map((item) => {
        const matchedService = servicesList.find(s => s.medical_service_id === item.item_id) || {};
        return {
          items: item.item_id,
          quantity: item.quantity,
          price: item.subtotal / item.quantity, // assuming quantity is not 0
          amount: item.subtotal,
        };
      });

      setItemsList(initialItemsList);
      setSubtotal(data.subtotal || 0);
      setDiscount(discount || 0);
      setTax(data.tax || 0);
      setNotes(note || "");
      setReferredBy(referred_by || "");
      setSelectedPatientId(patient_id);
      setSelectedPatientName(name);
      setInvoiceDate(invoice_date);
      setDueDate(due_date);


      // Set other fields
      // document.getElementById("patientSelect").value = data.customer;
      // document.getElementById("invoiceDate").value = invoice_date;
      // document.getElementById("dueDate").value = due_date;
      document.getElementById("invoiceNumber").value = invoice_number;
      // document.getElementById("patientSelect").value = patient_id;
      document.getElementById("totalAmount").value = data.total_amount;
      //document.getElementById("partialPayment").value = data.partial_payment;
      // document.getElementById("balanceAmount").value =
      //   data.total_amount - data.partial_payment;
      document.getElementById("balanceAmount").value =
        data.total_amount;

      // calculateSubtotal();
      // calculateTotalAmount();
      // Update other fields as needed
      // ...
    }
  }, [location.state]);
  // useEffect(() => {
  //   if (authToken !== "") {
  //     const url =
  //       selectedCategory === "services"
  //         ? `${REACT_APP_BACKEND_ROUTE_URL}get_all_medical_services/`
  //         : `${REACT_APP_BACKEND_ROUTE_URL}get_all_medical_products/`;

  //     axios
  //       .get(url, { headers: headers })
  //       .then((res) => {
  //         const filteredItems =
  //           selectedCategory === "services"
  //             ? res.data.service_list.filter(
  //                 (item) => item.active && !item.expired
  //               )
  //             : res.data.product_list.filter(
  //                 (item) => item.active && !item.expired
  //               );

  //         setServices(filteredItems);
  //       })
  //       .catch((error) => {
  //         console.error(
  //           `Error fetching ${
  //             selectedCategory === "services" ? "services" : "products"
  //           }:`,
  //           error
  //         );
  //       });
  //   }
  // }, [selectedCategory]);
  useEffect(() => {
    if (authToken !== "") {
      axios
        .get(
          `${REACT_APP_BACKEND_ROUTE_URL}get_patient_list_with_aabha_info/`,
          {
            headers: headers,
          }
        )
        .then((res) => {
          setPatientList(res.data?.data);
        });

      axios
        .get(`${REACT_APP_BACKEND_ROUTE_URL}get_all_medical_services/`, {
          headers: headers,
        })
        .then((res) => {
          const filteredServices = res.data.service_list.filter(
            (service) => !service.expired && service.active
          );

          // Set the filtered services
          setServices(filteredServices);
        });
    }
  }, [authToken]);
  console.log("testing..", services);

  // const calculateSubtotal = () => {
  //   const calculatedSubtotal = itemsList.reduce((total, item) => total + parseFloat(item.amount || 0), 0);
  //   setSubtotal(calculatedSubtotal);
  // };

  // const calculateTotalAmount = () => {
  //   const totalAmount = subtotal - discount + tax;
  //   return totalAmount;
  // };
  // const calculateTotalAmount = () => {
  //   const itemsTotal = itemsList.reduce((total, item) => total + parseFloat(item.amount || 0), 0);
  //   const totalAmount = itemsTotal + tax - discount;
  //   return totalAmount;
  // };
  // const calculateTotalAmount = () => {
  //   const totalAmount = subtotal - (subtotal * discount / 100) + (subtotal * tax / 100);
  //   return totalAmount.toFixed(2);
  // };

  const handleAddItem = () => {
    setItemsList([
      ...itemsList,
      { items: "", quantity: "", price: "", amount: "", category: "services" },
    ]);
  };

  // const handleItemChange = (index, field, value) => {
  //   const updatedItemsList = [...itemsList];
  //   updatedItemsList[index][field] = value;

  //   if (field === "quantity" || field === "items") {
  //     const selectedService = services.find(
  //       (service) => service.medical_service_id === value
  //     );
  //     if (selectedService) {
  //       updatedItemsList[index].price = selectedService.fee.toFixed(2);
  //     }
  //   }

  //   if (field === "quantity" || field === "price") {
  //     const quantity = parseFloat(updatedItemsList[index].quantity) || 0;
  //     const price = parseFloat(updatedItemsList[index].price) || 0;
  //     updatedItemsList[index].amount = (quantity * price).toFixed(2);
  //   }

  //   setItemsList(updatedItemsList);
  // };
  // const handleItemChange = (index, field, value) => {
  //   const updatedItemsList = [...itemsList];

  //   if (field === "items") {
  //     // Update the selected item
  //     const selectedService = services.find(
  //       (service) => service.medical_service_id === value
  //     );
  //     if (selectedService) {
  //       updatedItemsList[index].items = value;
  //       updatedItemsList[index].price = parseFloat(selectedService.fee).toFixed(
  //         2
  //       );
  //       // Recalculate amount
  //       const quantity = parseFloat(updatedItemsList[index].quantity) || 0;
  //       updatedItemsList[index].amount = (
  //         quantity * selectedService.fee
  //       ).toFixed(2);
  //     } else {
  //       updatedItemsList[index].items = value;
  //       updatedItemsList[index].price = "";
  //       updatedItemsList[index].amount = "";
  //     }
  //   } else if (field === "quantity") {
  //     // Update quantity and recalculate amount
  //     updatedItemsList[index].quantity = value;
  //     const quantity = parseFloat(value) || 0;
  //     const price = parseFloat(updatedItemsList[index].price) || 0;
  //     updatedItemsList[index].amount = (quantity * price).toFixed(2);
  //   }

  //   setItemsList(updatedItemsList);
  // };

  const handleItemChange = (index, field, value) => {
    const updatedItemsList = [...itemsList];
    updatedItemsList[index][field] = value;

    if (field === "category") {
      updatedItemsList[index].category = value;
      updatedItemsList[index].items = "";
      updatedItemsList[index].price = "";
      updatedItemsList[index].amount = "";
    } else if (field === "items") {
      const selectedService = servicesList.find(
        (service) => service.medical_service_id === value
      );
      if (selectedService) {
        updatedItemsList[index].items = value;
        updatedItemsList[index].price = parseFloat(selectedService.fee).toFixed(2);
        const quantity = parseFloat(updatedItemsList[index].quantity) || 0;
        updatedItemsList[index].amount = (quantity * selectedService.fee).toFixed(2);
      } else {
        updatedItemsList[index].items = value;
        updatedItemsList[index].price = "";
        updatedItemsList[index].amount = "";
      }
    } else if (field === "quantity") {
      updatedItemsList[index].quantity = value;
      const quantity = parseFloat(value) || 0;
      const price = parseFloat(updatedItemsList[index].price) || 0;
      updatedItemsList[index].amount = (quantity * price).toFixed(2);
    }

    setItemsList(updatedItemsList);

    // Recalculate subtotal and balance amount
    const newSubtotal = updatedItemsList.reduce(
      (acc, item) => acc + parseFloat(item.amount || 0),
      0
    );
    setSubtotal(newSubtotal);
    updateBalanceAmount(
      newSubtotal,
      discount,
      tax,
      // parseFloat(document.getElementById("partialPayment").value || 0)
    );
  };

  // const handlePaymentChange = (value) => {
  //   const payment = parseFloat(value) || 0;
  //   const totalAmount = parseFloat(finalTotal) || 0;

  //   // Update balance amount
  //   const balanceAmount = totalAmount - payment;
  //   document.getElementById("balanceAmount").value = balanceAmount.toFixed(2);
  // };

  // const handleTotalChange = (field, value) => {
  //   if (field === "subtotal") {
  //     setSubtotal(parseFloat(value) || 0);
  //   } else if (field === "discount") {
  //     setDiscount(parseFloat(value) || 0);
  //   } else if (field === "tax") {
  //     setTax(parseFloat(value) || 0);
  //   }
  // };

  // const handleSubmit = (event) => {
  //   event.preventDefault();

  //   // Retrieve values from form input fields
  //   const invoiceDate = document.getElementById('invoiceDate').value;
  //   const dueDate = document.getElementById('dueDate').value;
  //   const invoiceNumber = document.getElementById('invoiceNumber').value;

  //   console.log('Submitted Data:', { itemsList, subtotal, discount, tax, notes, invoiceDate, dueDate, invoiceNumber });

  //   // Assuming that invoiceData should be an object with the required data
  //   const invoiceData = {
  //     itemsList,
  //     subtotal,
  //     discount,
  //     tax,
  //     notes,
  //     invoiceDate,
  //     dueDate,
  //     invoiceNumber,
  //   };

  //   // Render the InvoicePreview component and pass invoiceData as state
  //   history.push('/invoicePreview'); // Update the route if needed
  // };
  const handleSubmit = (event) => {
    event.preventDefault();

    // const invoiceDate = document.getElementById("invoiceDate").value;
    // const dueDate = document.getElementById("dueDate").value;
    const invoiceNumber = document.getElementById("invoiceNumber").value;
    // const partial_payment = document.getElementById("partialPayment").value;
    const totalAmount = document.getElementById("totalAmount").value;
    const tax = document.getElementById("tax").value;

    if (new Date(dueDate) < new Date(invoiceDate)) {
      toast.error("Due date must be after invoice date");
      return;
    }

    const tot = calculateTotalAmount();
    if (isNaN(tot) || tot <= 0) {
      toast.error("Total amount must be greater than 0");
      return;
    }

    const filteredItems = itemsList.filter(
      (i) => i.items && i.quantity !== ""
    );

    if (filteredItems.length !== itemsList.length) {
      toast.error("Please select item and quantity for all rows.");
      return;
    }

    // const filteredItems = itemsList.filter(
    //   (item) =>
    //     item.items &&
    //     item.quantity != null &&
    //     item.quantity != null &&
    //     item.quantity !== ""
    // );

    // Check if any required item or quantity is not selected
    if (filteredItems.length !== itemsList.length) {
      console.log(filteredItems.length);
      console.log(itemsList.length);
      toast.error("Please select an item and enter the quantity for all rows.");
      return;
    }

    // const tot = document.getElementById("totalAmount").value;
    // Validate total_amount
    if (isNaN(tot) || tot <= 0) {
      toast.error("Total amount must be a valid number greater than 0.");
      return;
    }
    // console.log("partial_payment",partial_payment)
    // console.log("totalAmount",totalAmount)
    //     if (partial_payment<totalAmount){
    //       toast.error("Payment should not be greater than the Invoice Amount  ");
    //       return;
    //     }

    //const partialPaymentNumber = parseFloat(partial_payment);
    const tot_AmountNumber = parseFloat(totalAmount);
    //console.log("partial_payment", partialPaymentNumber);
    console.log("totalAmount", tot_AmountNumber);

    // if (partialPaymentNumber > tot_AmountNumber) {
    //   toast.error("Payment should not be greater than the Invoice Amount");
    //   return;
    // }

    // Create items array from itemsList state
    const items = itemsList.map((item) => ({
      item_id: item.items,
      quantity: parseInt(item.quantity, 10) || 0,
    }));

    // Create the data object
    const invoiceData = {
      invoice_number: invoiceNumber,
      // total_amount: totalAmount,
      total_amount: tot,
      invoice_date: invoiceDate,
      due_date: dueDate,
      patient_id: selectedPatientId,
      items: items,
      note: notes,
      referred_by: String(referredBy || "").trim(),
      discount: discount,
      //partial_payment: partial_payment,
      hip_id: facilityName,
      tax: tax,
    };
    const { data: locationData } = location.state || {};
    const paymentStatus = (locationData?.payment_status || "").toLowerCase();

    axios
      .post(
        `${REACT_APP_BACKEND_ROUTE_URL}update_invoice/`,
        JSON.stringify(invoiceData),
        {
          headers: headers,
        }
      )
      .then((response) => {
        console.log("invoice submitted successfully:", response.data);
        if (response.data.status === "Success") {
          toast.success(response.data.message);
          if (paymentStatus === "pending") {
            // Build invoice object for payment modal (same shape as InvoicePayment expects)
            const paymentInvoice = {
              invoice_id: locationData?.invoice_id,
              invoice_number: invoiceNumber,
              total_amount: parseFloat(tot),
              patient_name: selectedPatientName,
              patient_id: selectedPatientId,
              referred_by: String(referredBy || "").trim(),
              items: itemsList
                .filter((i) => i.items && i.quantity !== "")
                .map((item) => ({
                  item_id: item.items,
                  quantity: parseInt(item.quantity, 10) || 0,
                  subtotal: parseFloat(item.amount || 0),
                })),
              serviceMaster: services,
              patientMaster: patientList,
            };
            setInvoiceForPayment(paymentInvoice);
            setOpenPaymentModal(true);
          } else {
            setTimeout(() => {
              history.push("/doctor/invoice");
            }, 2000);
          }
        } else {
          console.error("Error submitting estimate:", response.data.message);
        }
      })
      .catch((error) => {
        console.error("Error submitting invoice:", error);
        // Handle errors (e.g., show error message to the user)
      });

    console.log("Submitted Data:", invoiceData);
  };
  // useEffect(() => {
  //   const subtotal = itemsList.reduce(
  //     (acc, item) => acc + parseFloat(item.amount),
  //     0
  //   );

  //   const total = subtotal * (1 - discount / 100) * (1 + tax / 100);

  //   setFinalTotal(total.toFixed(2));
  // }, [itemsList, discount, tax]);

  const handleRemoveItem = (indexToRemove) => {
    const updatedItemsList = itemsList.filter(
      (item, index) => index !== indexToRemove
    );
    setItemsList(updatedItemsList);

    // Recalculate subtotal after removing the item
    const newSubtotal = updatedItemsList.reduce(
      (acc, item) => acc + parseFloat(item.amount || 0),
      0
    );
    setSubtotal(newSubtotal);

    // Recalculate balance amount
    // const payment = parseFloat(
    //   document.getElementById("partialPayment").value || 0
    // );
    updateBalanceAmount(newSubtotal, discount, tax);
  };

  const handleNotesChange = (value) => {
    setNotes(value);
  };

  const handleGoBack = () => {
    history.push("/doctor/invoice");
  };

  // const updateBalanceAmount = (subtotal, discount, tax, payment) => {
  //   const totalAmount = subtotal * (1 - discount / 100) * (1 + tax / 100) || 0;
  //   setFinalTotal(totalAmount.toFixed(2));

  //   const balanceAmount = totalAmount - payment;
  //   document.getElementById("balanceAmount").value = balanceAmount.toFixed(2);
  // };
  // const updateBalanceAmount = (subtotal, discount, tax, payment) => {
  //   const totalAmount = subtotal * (1 - discount / 100) * (1 + tax / 100) || 0;
  //   setFinalTotal(totalAmount.toFixed(2));

  //   const balanceAmount = totalAmount - payment;
  //   document.getElementById("balanceAmount").value = balanceAmount.toFixed(2);
  // };
  const updateBalanceAmount = (subtotal, discount, tax) => {
    const totalAmount = subtotal * (1 - discount / 100) * (1 + tax / 100) || 0;
    setFinalTotal(totalAmount.toFixed(2));

    // const balanceAmount = totalAmount - payment;
    const balanceAmount = totalAmount;
    document.getElementById("balanceAmount").value = balanceAmount.toFixed(2);
  };

  return (
    <>
      <SideNavbar>
        <form onSubmit={handleSubmit}>
          {/* <Grid container>
          <Grid item xs={12} sm={12} md={6}>
            <div className="back-icon" onClick={handleGoBack}>
              <ArrowBackIcon />
            </div>
          </Grid>
          <Grid item xs={12} sm={12} md={6}></Grid>
        </Grid> */}
          <Card
            sx={{
              // boxShadow: "0px 10px 20px rgba(0, 0, 0, 0.25)",
              borderRadius: "8px",
              padding: "5px 10px",
              margin: "5px 10px",
            }}
          >
            {/* <Grid container>
              <Grid item xs={12} sm={12} md={6}>
                <div className="back-icon" onClick={handleGoBack}>
                  <ArrowBackIcon />
                </div>
              </Grid>
              <Grid item xs={12} sm={12} md={6}></Grid>
            </Grid> */}
            <p style={{ fontWeight: "bold", fontSize: "32px", color: "#172935", marginBottom: "16px" }}>Billing  Invoices</p>
            <Grid container spacing={4} style={{ alignItems: "flex-start" }}>
              {/* Patient Field (Left Side) */}
              <Grid item xs={12} sm={6} md={6}>
                <label htmlFor="patient" className="required-label">
                  Patient{" "}
                </label>
                {(() => {
                  const selectedPatient =
                    patientList.find((p) => p.patient_id === selectedPatientId) ||
                    (selectedPatientId && selectedPatientName
                      ? { patient_id: selectedPatientId, name: selectedPatientName }
                      : null);

                  if (!selectedPatient) {
                    return (
                      <Card
                        sx={{
                          borderRadius: "10px",
                          border: "1px dashed #125386",
                          boxShadow: "none",
                        }}
                      >
                        <CardContent sx={{ display: "flex", gap: 2, alignItems: "center" }}>
                          <Avatar sx={{ bgcolor: "#213360", width: 56, height: 56 }}>
                            P
                          </Avatar>
                          <div style={{ minWidth: 0 }}>
                            <Typography sx={{ fontWeight: 700 }}>
                              No patient selected
                            </Typography>
                            <Typography variant="body2" sx={{ color: "#6B7A90" }}>
                              Patient cannot be changed on edit.
                            </Typography>
                          </div>
                        </CardContent>
                      </Card>
                    );
                  }

                  const photoSrc = normalizeBase64Image(selectedPatient.photo);
                  const gender = selectedPatient.gender || "-";
                  const dob = selectedPatient.dob || "-";
                  const age =
                    selectedPatient.age !== undefined && selectedPatient.age !== null
                      ? `${selectedPatient.age}`
                      : "-";
                  const phone =
                    selectedPatient.phone_no ||
                    selectedPatient.phone_number ||
                    "-";


                  return (
                    <Card
                      sx={{
                        borderRadius: "10px",
                        border: "1px solid #125386",
                        boxShadow: "none",
                      }}
                    >
                      <CardContent sx={{ display: "flex", gap: 2, alignItems: "center" }}>
                        <Avatar
                          src={photoSrc || undefined}
                          alt={displayPatientName(selectedPatient.name, "Patient")}
                          sx={{ width: 56, height: 56, bgcolor: "#213360" }}
                        >
                          {String(selectedPatient?.name || "P")
                            .slice(0, 1)
                            .toUpperCase()}
                        </Avatar>
                        <div style={{ minWidth: 0 }}>
                          <Typography sx={{ fontWeight: 800, textTransform: "uppercase" }}>
                            {displayPatientName(selectedPatient.name, "-")}
                          </Typography>
                          <Typography variant="body2">
                            Patient ID: {selectedPatient.patient_id || "-"}
                          </Typography>
                          <Typography variant="body2">
                            Gender: {gender} &nbsp;|&nbsp; DOB: {dob} &nbsp;|&nbsp; Age: {age}
                          </Typography>
                          <Typography variant="body2">Phone: {phone}</Typography>

                        </div>
                      </CardContent>
                    </Card>
                  );
                })()}
              </Grid>

              {/* Right Side (Other Fields) */}
              <Grid item xs={12} sm={6} md={6} spacing={2}>
                <Grid container spacing={2}>
                  {/* Invoice Date */}
                  <Grid item xs={12} sm={6} md={6}>
                    <div className="input-wrapper">
                      <label htmlFor="invoiceDate" className="required-label">
                        Invoice Date{" "}
                      </label>
                      <div className="date-input-container" style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                        <input
                          type="date"
                          className="form-control"
                          id="invoiceDate"
                          name="invoiceDate"
                          value={invoiceDate}
                          required
                          disabled
                          max="2050-01-01"
                          style={{ paddingRight: '2.5rem' }}
                        />
                        <i
                          style={{
                            position: 'absolute',
                            right: '0.75rem',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            cursor: 'pointer',
                          }}
                        >
                          <CalendarIcon
                            onClick={() =>
                              document.getElementById("invoiceDate").showPicker?.()
                            }
                          />
                        </i>
                      </div>
                    </div>
                  </Grid>

                  {/* Expiry Date */}
                  <Grid item container xs={12} sm={6} md={6}>
                    <Grid item xs={12}>
                      <div className="input-wrapper">
                        <label htmlFor="dueDate" className="required-label">
                          Due Date{" "}
                        </label>
                        <div className="date-input-container" style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                          <input
                            required
                            type="date"
                            className="form-control"
                            id="dueDate"
                            name="dueDate"
                            value={dueDate}
                            max="2050-01-01"
                            style={{ paddingRight: '2.5rem' }}
                          />
                          <i
                            style={{
                              position: 'absolute',
                              right: '0.75rem',
                              top: '50%',
                              transform: 'translateY(-50%)',
                              cursor: 'pointer',
                            }}
                          >
                            <CalendarIcon
                              onClick={() =>
                                document.getElementById("dueDate").showPicker?.()
                              }
                            />
                          </i>
                        </div>
                      </div>
                    </Grid>
                  </Grid>
                  {/* Invoice Number */}
                  <Grid item xs={12}>
                    <div className="form-group">
                      <label htmlFor="invoiceNumber" className="required-label">
                        Invoice Number{" "}
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="invoiceNumber"
                        name="invoiceNumber"
                        required
                        readOnly
                      />
                    </div>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Card>

          <Card
            sx={{
              borderRadius: "8px",
              marginBottom: "25px",
              padding: "15px",
              margin: "5px 10px",
              boxShadow: "0px 2px 4px rgba(0,0,0,0.05)"
            }}
          >
            {itemsList.map((item, index) => (
              <Grid
                container
                spacing={2}
                key={index}
                sx={{
                  mb: 1,
                  p: 2,
                  borderRadius: "8px",
                  backgroundColor: "#E9F5FE", // Restoring the light blue background requested earlier
                  alignItems: "center"
                }}
              >
                {/* Category Selection */}
                <Grid item xs={12} sm={6} md={2}>
                  <RadioGroup
                    row
                    value={item.category || "services"}
                    onChange={(e) => handleItemChange(index, "category", e.target.value)}
                  >
                    <FormControlLabel value="services" control={<Radio size="small" />} label="Services" />
                    <FormControlLabel value="products" control={<Radio size="small" />} label="Products" />
                  </RadioGroup>
                </Grid>

                {/* Item Selection */}
                <Grid item xs={12} sm={6} md={3}>
                  <select
                    className="form-control"
                    style={{ borderRadius: "8px", border: "1px solid #ced4da" }}
                    value={item.items}
                    onChange={(e) => {
                      if (e.target.value === "new") {
                        setActiveRowIndex(index);
                        setOpenCreateServiceModal(true);
                        return;
                      }
                      handleItemChange(index, "items", e.target.value);
                    }}
                  >
                    <option value="">Select Item</option>
                    {item.category === "services" && <option value="new">+ Create New Service</option>}
                    {(item.category === "products" ? productsList : servicesList).map((option) => (
                      <option
                        key={option.medical_service_id || option.product_id}
                        value={option.medical_service_id || option.product_id}
                      >
                        {option.name}
                      </option>
                    ))}
                  </select>
                </Grid>

                {/* Quantity Field */}
                <Grid item xs={12} sm={4} md={2}>
                  <input
                    type="number"
                    className="form-control"
                    style={{ borderRadius: "8px", border: "1px solid #ced4da" }}
                    placeholder="Enter quantity"
                    value={item.quantity}
                    onChange={(e) =>
                      handleItemChange(index, "quantity", e.target.value)
                    }
                    min="0"
                    onKeyDown={(e) => {
                      if (e.key === "-" || e.key === "+") {
                        e.preventDefault();
                      }
                    }}
                  />
                </Grid>

                {/* Price Field */}
                <Grid item xs={12} sm={4} md={2}>
                  <input
                    type="text"
                    className="form-control"
                    style={{ borderRadius: "8px", border: "1px solid #ced4da", backgroundColor: "#fff" }}
                    value={item.price}
                    readOnly
                    placeholder="Price"
                  />
                </Grid>

                {/* Amount Field */}
                <Grid item xs={12} sm={4} md={2}>
                  <input
                    type="text"
                    className="form-control"
                    style={{ borderRadius: "8px", border: "1px solid #ced4da", backgroundColor: "#fff" }}
                    value={item.amount}
                    readOnly
                    placeholder="Amount"
                  />
                </Grid>

                {/* Action Field */}
                <Grid item xs={12} sm={12} md={1}>
                  <Button
                    variant="contained"
                    sx={{
                      backgroundColor: "#bdbdbd",
                      color: "white",
                      minWidth: "80px",
                      padding: "6px 12px",
                      fontSize: "12px",
                      fontWeight: "bold",
                      "&:hover": { backgroundColor: "#9e9e9e" }
                    }}
                    onClick={() => handleRemoveItem(index)}
                  >
                    REMOVE
                  </Button>
                </Grid>
              </Grid>
            ))}

            <Grid
              container
              spacing={2}
              alignItems="center"
              justifyContent="center"
              style={{ outline: 'none !important', border: 'none !important' }}
            >
              <Grid item xs={12}>
                <center>
                  <button
                    // variant="contained"
                    // size="medium"
                    type="button"
                    className="btn btn__secondary btn__rounded btn__block mt-2"
                    onClick={handleAddItem}
                    style={{
                      color: "white",
                      padding: "8px 16px",
                      width: "25%",
                      // transition: "background-color 0.3s ease",
                      backgroundColor: "#125386",
                      borderRadius: "10px",
                      // boxShadow: "0px 4px 4px 0px #00000040 inset"
                    }}
                  // startIcon={<AddIcon />}
                  >
                    + ADD
                  </button></center>
              </Grid>
            </Grid>
          </Card>
          <Card
            sx={{
              borderRadius: "8px",
              marginBottom: "25px",
              padding: "5px 10px",
              margin: "5px 10px",
            }}>
            {/* <div className="contact-panel">
            <div style={{ outline: 'none', border: 'none' }}> */}
            <Grid container spacing={2}
              alignItems="center"
              justifyContent="center"
              style={{ outline: 'none', border: 'none', boxShadow: 'none' }}>
              {/* Notes Section */}
              <Grid item xs={12} sm={6}>
                <div style={{ maxWidth: '100%', flexGrow: 1 }}>
                  {/* <label htmlFor="notes">Notes</label> */}
                  <textarea
                    id="notes"
                    name="notes"
                    placeholder="Notes"
                    value={notes}
                    onChange={(e) => handleNotesChange(e.target.value)}
                    style={{
                      width: "100%",
                      height: "415px",
                      borderRadius: "2%",
                      // border: '1px solid #ccc',
                      // boxShadow: "0px -3px 4px 0px #00000040 inset",
                      padding: "12px 16px"
                    }}
                    className="responsive-textarea"
                  />
                </div>
              </Grid>

              {/* Balance Amount Section */}
              <Grid item xs={12} sm={5} md={5} lg={4} style={{ marginLeft: "auto" }}>
                {/* <div className="card" style={{ padding: "30px", borderRadius: "10px" }}>
                  <div className="total-section"> */}
                <Grid container>
                  <Grid item xs={12}>
                    <div className="form-group">
                      <label htmlFor="referredBy" style={{ color: "#808285" }}>
                        Referred By
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="referredBy"
                        name="referredBy"
                        value={referredBy}
                        onChange={(e) => setReferredBy(e.target.value)}
                        placeholder="Enter referred by"
                        style={{ width: "100%" }}
                      />
                    </div>
                  </Grid>

                  <Grid item xs={12}>
                    <div className="form-group">
                      <label htmlFor="discount" style={{ color: "#808285" }}>Balance Amount (Rs)</label>
                      <input
                        type="text"
                        className="form-control"
                        id="balanceAmount"
                        name="balanceAmount"
                        readOnly
                        style={{ width: "100%" }}
                      />
                    </div>
                  </Grid>


                  <Grid item xs={12}>
                    <div className="form-group">
                      <label htmlFor="discount" style={{ color: "#808285" }}>Discount (%) {" "}</label>
                      <input
                        type="text"
                        className="form-control"
                        id="discount"
                        name="discount"
                        value={discount}
                        onChange={(e) =>
                          handleTotalChange("discount", e.target.value)
                        }
                        min="0"
                        onKeyDown={(e) => {
                          if (e.key === "-" || e.key === "+") {
                            e.preventDefault();
                          }
                        }}
                        style={{ width: "100%" }}
                      />
                    </div>
                  </Grid>
                  <Grid item xs={12}>
                    <div className="form-group">
                      <label htmlFor="tax" style={{ color: "#808285" }}>Add Tax (%) {" "}</label>
                      <input
                        type="tax"
                        className="form-control"
                        id="tax"
                        name="tax"
                        value={tax}
                        onChange={(e) =>
                          handleTotalChange("tax", e.target.value)
                        }
                        min="0"
                        onKeyDown={(e) => {
                          if (e.key === "-" || e.key === "+") {
                            e.preventDefault();
                          }
                        }}
                        style={{ width: "100%" }}
                      />
                    </div>
                  </Grid>
                  <Grid item xs={12}>
                    <div className="form-group">
                      <label htmlFor="totalAmount" style={{ color: "#808285" }}>TOTAL AMOUNT(Rs)</label>
                      <input
                        type="text"
                        className="form-control"
                        id="totalAmount"
                        name="totalAmount"
                        value={finalTotal}
                        readOnly
                        style={{ width: "100%" }}
                      />
                    </div>
                  </Grid>
                </Grid>
                {/* </div> */}
                {/* </div> */}
              </Grid>
            </Grid>

            <Grid
              container
              spacing={2}
              alignItems="center"
              justifyContent="center"
              style={{ marginTop: "5px", marginBottom: "5px" }}
            >
              <Grid item xs={6}>
                <center>
                  <button
                    // variant="contained"
                    // size="medium"
                    type="submit"
                    className="btn btn__secondary btn__rounded btn__block mt-2"
                    style={{
                      color: "white",
                      padding: "8px 16px",
                      width: "50%",
                      // transition: "background-color 0.3s ease",
                      backgroundColor: "#125386",
                      borderRadius: "10px",
                      // boxShadow: "0px 4px 4px 0px #00000040 inset"
                    }}
                  >
                    Submit
                  </button></center>
              </Grid>
              <Grid item xs={6}>
                <center>
                  <button
                    type="button"
                    onClick={handleGoBack}
                    // variant="contained"
                    // size="medium"
                    className="btn btn__secondary btn__rounded btn__block mt-2"
                    style={{
                      color: "white",
                      padding: "8px 16px",
                      width: "50%",
                      // transition: "background-color 0.3s ease",
                      backgroundColor: "#125386",
                      borderRadius: "10px",
                      // boxShadow: "0px 4px 4px 0px #00000040 inset"
                    }}
                  >
                    CANCEL
                  </button></center>
              </Grid>
            </Grid>

            {/* </div> */}
            {/* </div> */}
          </Card>
        </form>

        <ServiceAdditionOnTheGo
          open={openCreateServiceModal}
          onClose={() => setOpenCreateServiceModal(false)}
          onCreated={handleServiceCreated}
        />

        <Dialog
          open={openPatientSearch}
          onClose={() => setOpenPatientSearch(false)}
          fullWidth
          maxWidth="md"
        >
          <DialogTitle
            sx={{
              backgroundColor: "#213360",
              color: "#FFFFFF",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <span>Search Patient</span>
            <IconButton onClick={() => setOpenPatientSearch(false)}>
              <span style={{ color: "#FFFFFF", fontSize: 22 }}>×</span>
            </IconButton>
          </DialogTitle>
          <DialogContent dividers>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <label className="required-label">Search By</label>
                <StyledTextFieldBootstrap
                  fullWidth
                  select
                  value={patientSearchType}
                  onChange={(e) => {
                    setPatientSearchType(e.target.value);
                    setPatientSearchResults([]);
                    setSelectedPatientSearchId("");
                  }}
                >
                  <MenuItem value="patientId">Patient ID</MenuItem>
                  <MenuItem value="abhaId">ABHA Address</MenuItem>
                  <MenuItem value="abhaNo">ABHA No</MenuItem>
                  <MenuItem value="phoneNo">Phone No</MenuItem>
                  <MenuItem value="demographics">Demographics</MenuItem>
                </StyledTextFieldBootstrap>
              </Grid>
              <Grid item xs={12} sm={6}>
                <label>Enter Search Query</label>
                <StyledTextFieldBootstrap
                  fullWidth
                  placeholder="Enter your search query"
                  value={patientSearchQuery}
                  onChange={(e) => setPatientSearchQuery(e.target.value)}
                  disabled={patientSearchType === "demographics"}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <label>Name</label>
                <StyledTextFieldBootstrap
                  fullWidth
                  placeholder="Enter patient name"
                  value={patientSearchName}
                  onChange={(e) => setPatientSearchName(e.target.value)}
                  disabled={patientSearchType !== "demographics"}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <label>Gender</label>
                <StyledTextFieldBootstrap
                  fullWidth
                  select
                  value={patientSearchGender}
                  onChange={(e) => setPatientSearchGender(e.target.value)}
                  disabled={patientSearchType !== "demographics"}
                >
                  <MenuItem value="">Select Gender</MenuItem>
                  <MenuItem value="M">Male</MenuItem>
                  <MenuItem value="F">Female</MenuItem>
                  <MenuItem value="O">Other</MenuItem>
                </StyledTextFieldBootstrap>
              </Grid>
              <Grid item xs={12} sm={4}>
                <label>Date of Birth</label>
                <StyledTextFieldBootstrap
                  fullWidth
                  type="date"
                  value={patientSearchDob}
                  onChange={(e) => setPatientSearchDob(e.target.value)}
                  disabled={patientSearchType !== "demographics"}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
            </Grid>
            <div style={{ marginTop: 16 }}>
              <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
                Results
              </Typography>
              {isPatientSearching ? (
                <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                  <CircularProgress size={20} />
                  <span>Searching…</span>
                </div>
              ) : patientSearchResults && patientSearchResults.length > 0 ? (
                <Grid container spacing={2}>
                  {patientSearchResults.map((p) => {
                    const isSelected = selectedPatientSearchId === p.patient_id;
                    const phoneVal = p.phone_no || p.phone_number || "-";
                    return (
                      <Grid item xs={12} sm={6} key={p.patient_id}>
                        <Card
                          onClick={() => {
                            setSelectedPatientSearchId(p.patient_id);
                            selectPatientFromSearch(p);
                          }}
                          sx={{
                            cursor: "pointer",
                            border: isSelected
                              ? "2px solid #21cdc0"
                              : "1px solid #E3EFF0",
                            borderRadius: "10px",
                          }}
                        >
                          <CardContent sx={{ display: "flex", gap: 2 }}>
                            <Avatar
                              src={normalizeBase64Image(p?.photo) || undefined}
                              alt={p?.name || "Patient"}
                              sx={{ bgcolor: "#213360" }}
                            >
                              {String(p?.name || "P").slice(0, 1).toUpperCase()}
                            </Avatar>
                            <div style={{ minWidth: 0 }}>
                              <Typography sx={{ fontWeight: 700 }}>
                                {p?.name || "-"}
                              </Typography>
                              <Typography variant="body2">
                                Patient ID: {p?.patient_id || "-"}
                              </Typography>
                              <Typography variant="body2">
                                Phone: {phoneVal}
                              </Typography>
                              <Typography variant="body2">
                                ABHA Number: {p?.abha_no || "-"}
                              </Typography>
                              <Typography variant="body2">
                                ABHA Address: {p?.abha_id || "-"}
                              </Typography>
                            </div>
                          </CardContent>
                        </Card>
                      </Grid>
                    );
                  })}
                </Grid>
              ) : (
                <Typography variant="body2" sx={{ color: "#6B7A90" }}>
                  No results to show.
                </Typography>
              )}
            </div>
          </DialogContent>
          <DialogActions sx={{ px: 3, py: 2 }}>
            <Button
              type="button"
              variant="outlined"
              onClick={() => setOpenPatientSearch(false)}
            >
              Close
            </Button>
            <Button
              type="button"
              variant="contained"
              onClick={runPatientSearch}
              disabled={isPatientSearching}
              style={{ backgroundColor: "#0e3f66" }}
            >
              Search
            </Button>
          </DialogActions>
        </Dialog>

        <InvoicePayment
          open={openPaymentModal}
          onClose={() => {
            setOpenPaymentModal(false);
            setInvoiceForPayment(null);
          }}
          invoice={invoiceForPayment}
          onAfterClose={() => {
            setOpenPaymentModal(false);
            setInvoiceForPayment(null);
            history.push("/doctor/invoice");
          }}
        />
      </SideNavbar>
    </>
  );
};

export default EditInvoice;